export enum ENVIRONMENTS {
  STAGING = "staging",
  LOCALSHEHAN = "localshehan",
}
export const ENVIRONMENT_MODE: string = ENVIRONMENTS.STAGING;

export const BASE_URLS: {
  [key: string]: {
    REACT_APP_API_BASE_URL: string;
  };
} = {
  staging: {
    REACT_APP_API_BASE_URL: "https://etablebackend.darkhorsesolutions.co/",
  },
  localshehan: {
    REACT_APP_API_BASE_URL: "http://192.168.100.5:4000/",
  },
};

export enum UserCompanyFundingSources {
  "bootstrapped" = "Bootstrapped",
  "vc_backed" = "VC-backed / Raised capital",
}

export enum UserCompanyIndustries {
  aerospacedefense = "Aero Space Defense",
  agriculturelivestock = "Agriculture Live Stock",
  automotive = "Automotive",
  businessservices = "Business Services",
  construction = "Construction",
  consumerservices = "Consumer Services",
  educationtraining = "Education Training",
  privateequity = "Private Equity",
}
